import React, {useState, useEffect, useContext, useRef} from 'react';
import { SideBarContext } from '_context/LayoutContext';
import { InfoWindowHook } from './InfoWindowHook';

const TbtInfoWindow = (props) => {
    const [displayName, setDisplayName] = useState('')
    const [tbtInfoName, setTbtInfoName] = useState('')
    const {setDisplay, location} = InfoWindowHook(props, 18, 90, 302, 86, 'TbtInfoWindow'); 

    useEffect(() => {
        if(props.marker){
            let attr = props.marker.attribute
            setDisplayName(attr.displayName)
            setTbtInfoName(attr.tbtInfoName)
        }
    }, [props.marker])

    const nextorPrevClick = (type)=>{
        if(type=='next' && props.marker && props.marker.next){
            props.nextClick(props.marker.next)
        }else if(type=='prev' && props.marker && props.marker.prev){
            props.nextClick(props.marker.prev)
        }
    }

    return (
        <div className="lyBox innerMap botLeft simple" style={{left:location.x, top:location.y, display:location.display, opacity:location.opacity}}>
            <div className="title">
                {/* <img src="../imgs/data/tbt_sample.png" alt="" className="tbt"/> */}
                <div className="txt1">{displayName}</div>
                <div className="txt2">{tbtInfoName}</div>
            </div>
            <div className="routeMove">
                <button className="btnsBg btnPrev" onClick={(e) => nextorPrevClick('prev')}>이전</button>
                <button className="btnsBg btnNext" onClick={(e) => nextorPrevClick('next')}>다음</button>
            </div>
            <button className="btnsSch btnClose" onClick={(e) => {setDisplay('none'); props.close()}}>닫기</button>
	    </div>
    )
}

export default TbtInfoWindow